export default __webpack_public_path__ + "static/media/task-priority.d36370c4.svg";